import mixpanel from "mixpanel-browser/src/loaders/loader-module-core";
import {getCurrentUser} from "aws-amplify/auth";

export const MixMsDebounceWait = 5000;

export enum BaseActions {
  pageLoad = 'PAGE_LOAD',
  fieldsEdit = 'FIELDS_EDIT',
  openModal = 'OPEN_MODAL',
  closeModal = 'CLOSE_MODAL',
  submitClick = 'SUBMIT_CLICK',
  navigateAway = 'NAVIGATE_AWAY',
}

const sensitiveKeyPattern = /email|phone|password|fileName|file_name|referencePhoto/i;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

// Drops PII-looking keys from the event's top level and one level of nested objects (arrays are walked at the same depth)
export function redactEventProperties<T>(properties: T, depth: number = 0): T {
  if (Array.isArray(properties)) {
    return properties.map(item => redactEventProperties(item, depth)) as unknown as T;
  }
  if (!isPlainObject(properties)) {
    return properties;
  }

  const redacted: Record<string, unknown> = {};
  Object.entries(properties).forEach(([key, value]) => {
    if (sensitiveKeyPattern.test(key)) {
      return;
    }
    redacted[key] = depth < 1 ? redactEventProperties(value, depth + 1) : value;
  });
  return redacted as T;
}

export async function optInMixPanel() {
  if (mixpanel.has_opted_in_tracking()) {
    return;
  }

  mixpanel.opt_in_tracking();
  mixpanel.register({
    "isLoggedIn": (await getCurrentUser().catch(err => undefined)) !== undefined,
  })
}

export function optOutMixPanel() {
  mixpanel.opt_out_tracking();
}

export function sendMixEvent(eventName: string, event: any) {
  if (mixpanel.has_opted_in_tracking()) {
    mixpanel.track(eventName, redactEventProperties(event));
  }
}

export function getMixPanelId() {
  return mixpanel.get_distinct_id();
}
